var exports = {
  "k": "xa15a2ab7--7e81cd--container",
  "K": "xa15a2ab7--7e81cd--icon",
};

module.exports = exports;
